import { useContext } from "react";
import { TigerContext } from "./TigerContext";

export function useTiger() {
  const ctx = useContext(TigerContext);
  if (!ctx) throw new Error("useTiger debe usarse dentro de TigerContext");
  return ctx;
}